__webpack_require__.p = "/api/assets/";